import { unwrapEnvelopeOr } from '@/model/client';
import { useGetApiAuthMeQuery } from '@/model/user/api.generated';
import type { AuthMeResponse } from '@/model/user/dto.generated';

export function useIsPlatformAdmin(): { isPlatformAdmin: boolean; isLoading: boolean } {
  const { data, isLoading } = useGetApiAuthMeQuery();
  return {
    isPlatformAdmin:
      unwrapEnvelopeOr<AuthMeResponse | null>(data, null)?.is_platform_admin ?? false,
    isLoading,
  };
}
